// removed by extract-text-webpack-plugin
module.exports = {"Content":"_3sD8f","ContentInsurance":"_1jzEz","ContentGST":"_32OQw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Contents/AddonsContent/AddonsContent.scss
// module id = 560
// module chunks = 0